import { string, instanceOf, object, oneOfType, oneOf } from 'prop-types';
import styled from 'styled-components/macro';
import ErrorWrapper from 'components/styled/LoadingErrorWrapper/LoadingErrorWrapper';
import ErrorDetails from 'components/utility/ErrorDetails/ErrorDetails';

import { ReactComponent as ErrorIcon } from 'icons/error-icon.svg';

const Wrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  margin: 0;

  p {
    margin: 0;
  }

  svg {
    margin-right: ${({ theme }) => theme.spacing.small};
  }
`;

const Content = styled('div')`
  flex: 1 1 auto;
`;

export const Anchor = styled('a')`
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  border-bottom: 2px solid ${({ theme }) => theme.AccentGreen};
  line-height: 1.2;
  white-space: nowrap;

  &:hover {
    border-width: 3px;
  }
`;

const Button = Anchor.withComponent('button');

/** The ErrorDisplay component displays a generic error message, accompanied by more details about the error. */
const ErrorDisplay = ({ error, errorInfo, type, className }) => (
  <ErrorWrapper type={type} className={className} data-pw="error-content">
    <Wrapper>
      <ErrorIcon />
      <Content>
        <p>
          An error occurred, please{' '}
          <Button onClick={() => window.location.reload()}>refresh</Button> the
          page or{' '}
          <Anchor href="mailto:opus-support@wmg.com">
            contact Opus Support
          </Anchor>
          .
        </p>
        <ErrorDetails error={error} errorInfo={errorInfo} />
      </Content>
    </Wrapper>
  </ErrorWrapper>
);

ErrorDisplay.propTypes = {
  /** optional className for styled composition */
  className: string,
  /** An instance of the native Error object */
  error: instanceOf(Error).isRequired,
  /** An object with additional error information, like a stack trace, or request headers. */
  errorInfo: oneOfType([object, string]),
  /**The type of error that should be displayed. Changes styling */
  type: oneOf(['bundle', 'component']),
};

export default ErrorDisplay;
